<label [for]="controlId" class="field-label bd-field-label required">Secret</label>
<div class="input-wrapper">
  <input [id]="controlId" [formControl]="secretCtrl" name="secret" class="bd-text-input tall" />
  <ul class="input-actions">
    @if (this.secretCtrl.value) {
      <li>
        <button
          type="button"
          blazeIconButton
          blazeTooltip="Copy to Clipboard"
          (click)="copySecretToClipboard()"
        >
          <mat-icon svgIcon="icon_copy_to_clipboard_16" />
        </button>
      </li>
    }
    <li>
      <button
        type="button"
        blazeIconButton
        blazeTooltip="Generate new secret"
        (click)="generateNewSecret()"
      >
        <mat-icon svgIcon="icon_reload_16" />
      </button>
    </li>
  </ul>
</div>
